import type { NotificationCardComponent } from 'src/notifications/cardTypes';
import { NOTIFICATION_CARDS } from 'src/notifications/notificationCards';
import type { Notification, NotificationType } from 'src/notifications/types/Notification';

export default function NotificationCard({
  notification,
  onClose,
}: {
  notification: Notification;
  onClose: () => void;
}) {
  const { payload } = notification;
  // The registry is keyed by the discriminator, so the looked-up card and the payload always
  // match at runtime. TypeScript cannot correlate the two across the index, so the component is
  // widened here at the single dispatch point; every card is otherwise typed against its own payload.
  const Card = NOTIFICATION_CARDS[payload.type]
    .component as NotificationCardComponent<NotificationType>;

  return <Card notification={notification} payload={payload} onClose={onClose} />;
}
